import React, { FC } from 'react';
import {
  ManagerPropsWithLoadedRange,
  useProjectsWSManager,
  useTeamsWSManager,
  useUsersWSManager,
} from './managers';

interface Props extends ManagerPropsWithLoadedRange {
  projectIds: number[];
}

export const ResourceManagementSocketConnector: FC<Props> = (props) => {
  const {
    schedulerRef,
    groupBy,
    projectLookup,
    projects,
    userLookup,
    roleLookup,
  } = props;

  useUsersWSManager({
    schedulerRef,
    groupBy,
    projects,
    userLookup,
    projectLookup,
    roleLookup,
  });
  useProjectsWSManager(props);
  useTeamsWSManager(props);

  return <></>;
};
